function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 46.841874,46.426351 H 8.2774449 c -3.5597852,0 -6.4273983,-2.917965 -6.4273983,-6.540354 V 8.2910353 c 0,-3.6223606 2.8676131,-6.540366 6.4273983,-6.540366 H 46.841874 c 3.559794,0 6.427436,2.9180054 6.427436,6.540366 V 39.885997 c 0,3.622389 -2.867642,6.540354 -6.427436,6.540354 z M 8.2774449,3.7630916 c -2.4720697,0 -4.4497387,2.0124195 -4.4497387,4.5279437 V 39.885997 c 0,2.515572 1.977669,4.52801 4.4497387,4.52801 H 46.841874 c 2.472097,0 4.44972,-2.012438 4.44972,-4.52801 V 8.2910353 c 0,-2.5155242 -1.977623,-4.5279437 -4.44972,-4.5279437 z",
    fill: "#184665",
    id: "path1",
    style: {
      fill: "none",
      stroke: "#184665",
      strokeWidth: 2.027,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.135462,10.925835 c 0,-1.0794621 -0.837564,-2.0389773 -2.034003,-2.0389773 -1.196324,0 -2.153474,0.8395801 -2.033888,2.0389773 0,1.079497 0.837564,2.039023 2.033888,2.039023 1.076852,0 2.034003,-0.83967 2.034003,-2.039023 z",
    fill: "#ef652f",
    id: "path2",
    style: {
      strokeWidth: 1.14242
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.395153,12.964858 c -1.079444,0 -2.039,-0.83967 -2.039,-2.039023 0,-1.1993972 0.959556,-2.0389773 2.039,-2.0389773 1.079444,0 2.039,0.8395801 2.039,2.0389773 0,1.079497 -0.839555,2.039023 -2.039,2.039023 z",
    fill: "#ef652f",
    id: "path3",
    style: {
      strokeWidth: 1.14385
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.357448,12.965124 c -1.079284,0 -2.0387,-0.839725 -2.0387,-2.039156 0,-1.1994753 0.959416,-2.0391103 2.0387,-2.0391103 1.079286,0 2.038703,0.839635 2.038703,2.0391103 0,1.079568 -0.839547,2.039156 -2.038703,2.039156 z",
    fill: "#ef652f",
    id: "path4",
    style: {
      strokeWidth: 1.96535,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.463873,21.252835 25.589919,35.37074 c -0.202546,0.206053 -0.405092,0.309128 -0.708959,0.309128 -0.30377,0 -0.506316,-0.103075 -0.708862,-0.309128 l -5.671089,-5.770853 c -0.405092,-0.412204 -0.405092,-1.03046 0,-1.442664 0.405091,-0.412204 1.012631,-0.412204 1.417723,0 L 24.88096,33.206646 38.046149,19.81017 c 0.405092,-0.412204 1.012632,-0.412204 1.417724,0 0.405092,0.412204 0.405092,1.030461 0,1.442665 z",
    fill: "#ef652f",
    id: "path5",
    style: {
      strokeWidth: 2.174,
      strokeDasharray: "none",
      fillRule: "nonzero",
      stroke: "#ef6531",
      strokeOpacity: 1,
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.5c0032b1b7fd635bd785d45f0276629d.svg";
export { ForwardRef as ReactComponent };